import React from "react"
import classNames from "classnames"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons"

export interface AiInsightsPendingProps {
	message?: string
}

export function AiInsightsPending({message = "Generating recommendations"}: AiInsightsPendingProps) {
	return (
		<span className={classNames("ai-insights-pending")}>
			<span className="ai-insights-pending-icon">
				<FontAwesomeIcon icon={faCircleNotch} spin />
			</span>
			<span className="ai-insights-pending-label">{message}</span>
		</span>
	)
}
